export function calculateDefectScore(seriousness: number, intensity: number, extendPercentage: number): number {
    const extend = extendPercentage;

    // NEN Decision table.https://nl.wikipedia.org/wiki/Conditiemeting_(gebouw)
    const decisionTable = [
        // extend < 2%
        { seriousness: 1, intensity: 1, extend: 1, score: 1 },
        { seriousness: 1, intensity: 2, extend: 1, score: 1 },
        { seriousness: 1, intensity: 3, extend: 1, score: 1 },

        { seriousness: 2, intensity: 1, extend: 1, score: 1 },
        { seriousness: 2, intensity: 2, extend: 1, score: 1 },
        { seriousness: 2, intensity: 3, extend: 1, score: 1 },

        { seriousness: 3, intensity: 1, extend: 1, score: 1 },
        { seriousness: 3, intensity: 2, extend: 1, score: 1 },
        { seriousness: 3, intensity: 3, extend: 1, score: 2 },

        // extend 2% - 10%
        { seriousness: 1, intensity: 1, extend: 2, score: 1 },
        { seriousness: 1, intensity: 2, extend: 2, score: 1 },
        { seriousness: 1, intensity: 3, extend: 2, score: 1 },

        { seriousness: 2, intensity: 1, extend: 2, score: 1 },
        { seriousness: 2, intensity: 2, extend: 2, score: 1 },
        { seriousness: 2, intensity: 3, extend: 2, score: 2 },

        { seriousness: 3, intensity: 1, extend: 2, score: 1 },
        { seriousness: 3, intensity: 2, extend: 2, score: 2 },
        { seriousness: 3, intensity: 3, extend: 2, score: 3 },

        // extend 10% - 30%
        { seriousness: 1, intensity: 1, extend: 3, score: 1 },
        { seriousness: 1, intensity: 2, extend: 3, score: 1 },
        { seriousness: 1, intensity: 3, extend: 3, score: 2 },

        { seriousness: 2, intensity: 1, extend: 3, score: 1 },
        { seriousness: 2, intensity: 2, extend: 3, score: 2 },
        { seriousness: 2, intensity: 3, extend: 3, score: 3 },

        { seriousness: 3, intensity: 1, extend: 3, score: 2 },
        { seriousness: 3, intensity: 2, extend: 3, score: 3 },
        { seriousness: 3, intensity: 3, extend: 3, score: 4 },

        // extend 30% - 70%
        { seriousness: 1, intensity: 1, extend: 4, score: 1 },
        { seriousness: 1, intensity: 2, extend: 4, score: 2 },
        { seriousness: 1, intensity: 3, extend: 4, score: 3 },

        { seriousness: 2, intensity: 1, extend: 4, score: 2 },
        { seriousness: 2, intensity: 2, extend: 4, score: 3 },
        { seriousness: 2, intensity: 3, extend: 4, score: 4 },

        { seriousness: 3, intensity: 1, extend: 4, score: 3 },
        { seriousness: 3, intensity: 2, extend: 4, score: 4 },
        { seriousness: 3, intensity: 3, extend: 4, score: 5 },

        // extend 30% - 70%
        { seriousness: 1, intensity: 1, extend: 5, score: 2 },
        { seriousness: 1, intensity: 2, extend: 5, score: 3 },
        { seriousness: 1, intensity: 3, extend: 5, score: 4 },

        { seriousness: 2, intensity: 1, extend: 5, score: 3 },
        { seriousness: 2, intensity: 2, extend: 5, score: 4 },
        { seriousness: 2, intensity: 3, extend: 5, score: 5 },

        { seriousness: 3, intensity: 1, extend: 5, score: 4 },
        { seriousness: 3, intensity: 2, extend: 5, score: 5 },
        { seriousness: 3, intensity: 3, extend: 5, score: 6 },
    ];

    const decision = decisionTable.find(
        (item: any) => item.seriousness === Number(seriousness) && item.intensity === Number(intensity) && item.extend === Number(extend),
    );

    if (decision) {
        return decision.score;
    }
    return 0;
}
